module.exports = __webpack_public_path__ + "img/in.e4ab7bd.svg";